// extracted by mini-css-extract-plugin
module.exports = {"cols":"index_cols_9gqg-","svg":"index_svg_21N8P","right":"index_right_1G909","nowrap":"index_nowrap_sDt8Y","button":"index_button_1mtcN"};